// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"b52c12e5","498":"cdefe6de","703":"cdaca79f"}[chunkId] + ".chunk.js";
};